import React, { useState, useEffect } from 'react';
import { Spinner } from '../../../Components/Spinner/Spinner';
import { ProductThumb } from '../../../Components/Product/ProductThumb';
import { List, ListItem } from '../../../Components/List';
import IconBtn from '../../../Components/IconBtn';
import { demoteId, promoteId, pinId } from '../Ranking/utils';

type SearchProductType = {
	dimension,
	onAddProduct,
	searchTerm,
	searchProductsByTerm,
	arrayOfIdsToExcludes,
	allProduct,
	deleteList,
	searchDependency?,
	size?
	showTitle?
}

export default function SearchProducts({
	dimension,
	onAddProduct,
	searchTerm,
	searchProductsByTerm,
	arrayOfIdsToExcludes,
	allProduct,
	deleteList,
	searchDependency,
	size = 'm',
	showTitle = true
}: SearchProductType) {

	const [filteredSuggestions, setFilteredSuggestions] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const getListOfSpecificities = () => {
		function sortArrayProducts(a, b) {
			if (a.id < b.id) return -1;
			if (a.id > b.id) return 1;
			return 0;
		}
		setIsLoading(true);
		searchProductsByTerm((data: { products: any[]; }) => {
			setIsLoading(false);
			handleOnChange(searchTerm, [...data.products.sort(sortArrayProducts)]);
		});
	};

	useEffect(() => {
		if (searchTerm && searchTerm.length !== 0) {
			getListOfSpecificities();
		}
		return () => {
			setFilteredSuggestions([]);
		};
	}, [searchTerm, searchDependency]);

	useEffect(() => {
		filterSuggestions(searchTerm, filteredSuggestions);
	}, [arrayOfIdsToExcludes]);

	useEffect(() => {
		if (deleteList) {
			setFilteredSuggestions([]);
		}
	}, [deleteList]);

	const handleOnChange = (value, newList) => {
		if (!value) return;
		filterSuggestions(value, newList);
	};

	const filterSuggestions = (search, data) => {
		const newFilteredSuggestions = data
			.filter(suggestion => suggestion.name.toLowerCase().includes(search.toLowerCase()) || suggestion.id.toString().includes(search))
			.filter(suggestion => !arrayOfIdsToExcludes.includes(suggestion.id.toString()));

		setFilteredSuggestions(newFilteredSuggestions);
	};

	const take = (list, size) => {
		return list.slice(0, size);
	};

	const titles = {
		[promoteId]: 'Non-promoted products',
		[demoteId]: 'Non-demoted products',
		[pinId]: 'Non-pinned products'
	};

	return (
		<div>
			{isLoading &&
				<Spinner size="l" />
			}
			{searchTerm && (
				<>
					{filteredSuggestions.length > 0 && (
						<>
							{showTitle &&
								<div className='h4'>{titles[dimension]}</div>
							}
							<List size="s">
								{take(filteredSuggestions, 20).map((suggestion) => {
									return (
										<SearchProductItem
											key={suggestion.id}
											item={suggestion}
											onAddProduct={onAddProduct}
											size={size}
											allProduct={allProduct}
										/>
									);
								})}
							</List>
						</>
					)}
					{filteredSuggestions.length === 0 && !isLoading && (
						<div>
							No matching product in catalog
						</div>
					)}
				</>
			)}
		</div>
	);
}


type SearchProductItemType = {
	item,
	onAddProduct,
	allProduct,
	size?
}
export function SearchProductItem({ item, onAddProduct, size, allProduct }: SearchProductItemType) {
	return (<ListItem
		text={item.name}
		textHasEllipsis={true}
		textIsBold={false}
		description={item.id}
		picto={
			<ProductThumb
				url={item.urlThumbnail}
				alt={item.name}
				hasMargin={false}
				width={size === 's' ? 40 : 50}
			/>
		}
		actions={
			<IconBtn
				onClick={() => onAddProduct(!allProduct ? item.id : item)}
				icon="fas fa-plus-circle"
				tooltip="Add product"
				isActive={true}
				size="l"
			/>
		}
	/>);
}